import type { ServerSticker, Uuid } from "@shared/api";
import type { CustomEmoji } from "@shared/lib/emoji";
import { IconImagePlay } from "@shared/ui/icons";
import { ServerEmojiPicker } from "./ServerEmojiPicker";
import { StickerPicker } from "./StickerPicker";

export type ExpressionTab = "gif" | "stickers" | "emoji";

const TABS: { key: ExpressionTab; label: string }[] = [
  { key: "gif", label: "Гифки" },
  { key: "stickers", label: "Стикеры" },
  { key: "emoji", label: "Эмодзи" },
];

/**
 * Панель у поля ввода — как в Discord: одно окно с вкладками «Гифки»,
 * «Стикеры», «Эмодзи». Открывают её три кнопки поля, каждая на своей вкладке.
 * Знаки — та же панель, что у реакций (`ServerEmojiPicker`), только без своей
 * подложки: подложка здесь общая на все вкладки, и окно не меняет размер при
 * переключении.
 */
export function ExpressionPicker({
  tab,
  onTab,
  serverId,
  custom,
  stickers,
  server,
  onEmoji,
  onSticker,
}: {
  tab: ExpressionTab;
  onTab: (tab: ExpressionTab) => void;
  /** Сервер канала; `null` — личная переписка. */
  serverId: Uuid | null;
  custom: CustomEmoji[];
  stickers: ServerSticker[];
  server: { id: Uuid; name: string; icon_id: Uuid | null } | null;
  onEmoji: (value: string) => void;
  onSticker: (id: Uuid) => void;
}) {
  return (
    <div className="expr-panel surface-pop">
      <div className="expr-tabs" role="tablist">
        {TABS.map((item) => (
          <button
            key={item.key}
            type="button"
            role="tab"
            aria-selected={tab === item.key}
            className={`expr-tab ${tab === item.key ? "on" : ""}`}
            onClick={() => onTab(item.key)}
          >
            {item.label}
          </button>
        ))}
      </div>

      {tab === "emoji" && <ServerEmojiPicker embedded serverId={serverId} custom={custom} onPick={onEmoji} />}
      {tab === "stickers" && <StickerPicker stickers={stickers} server={server} onPick={onSticker} />}
      {tab === "gif" && (
        <div className="expr-soon">
          <IconImagePlay size={28} />
          <span className="expr-soon-title">
            Гифки <span className="plan-tag">план</span>
          </span>
          <span className="expr-soon-note">Поиск гифок ещё не подключён: здесь будут популярные, разделы и поиск, как в Discord.</span>
        </div>
      )}
    </div>
  );
}
